// extracted by mini-css-extract-plugin
export default {"cell-content":"cell-content__EPQFj"};